import { render, staticRenderFns } from "./ShopRates.vue?vue&type=template&id=6db2bd72&"
import script from "./ShopRates.vue?vue&type=script&lang=js&"
export * from "./ShopRates.vue?vue&type=script&lang=js&"
import style0 from "./ShopRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports